import { queryKeyFactory } from "@l2r-front/l2r-query"

export const NETWORKS_ROOT_QUERY_KEY = "networks"

export const networksQueryKeys = queryKeyFactory(NETWORKS_ROOT_QUERY_KEY, {
    network: (networkSlug) => [NETWORKS_ROOT_QUERY_KEY, "network", networkSlug] as const,
    referential: (networkSlug, filters) => [NETWORKS_ROOT_QUERY_KEY, "referential", networkSlug, filters] as const,
    roads: (networkSlug, filters) => [NETWORKS_ROOT_QUERY_KEY, "roads", networkSlug, filters] as const,
    features: (filters) => [NETWORKS_ROOT_QUERY_KEY, "features", filters] as const,
    stats: (networkSlug, subnetworkSlugs) => [NETWORKS_ROOT_QUERY_KEY, "stats", networkSlug, subnetworkSlugs] as const,
})
